/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './notifications.scss';

import PrismicLink from '../../Links/PrismicLink';

class Notifications extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const { homedashNotifications = [], 'data-testid': dataTestId } = this.props;
        return (
            <div className={`${styles.notifications}`} data-testid={dataTestId || undefined}>
                {homedashNotifications && homedashNotifications.length > 0 && (
                    <React.Fragment>
                        {homedashNotifications.map((notification, index) => {
                            if (notification.is_active) {
                                return (
                                    <div className={`${styles.notification} sub-header bg-transparent`} data-testid={dataTestId && `${dataTestId}.item-${index}`}>
                                        <div className={`d-flex align-items-center justify-content-center`}>
                                            <span style={{ color: notification.maintitlecolor }} data-testid={dataTestId && `${dataTestId}.item-${index}.copy`}>{(notification.hyperlinkwithcopy) ? <PrismicLink link={notification.hyperlinkwithcopy} target="_blank" rel="noopener noreferrer" data-testid={dataTestId && `${dataTestId}.item-${index}.link`}><a style={{ color: notification.maintitlecolor }}>{notification.copy}</a></PrismicLink> : notification.copy}</span>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

Notifications.propTypes = {
    homedashNotifications: PropTypes.array,
    'data-testid': PropTypes.string,
};

Notifications.defaultProps = {
    homedashNotifications: [],
    'data-testid': null,
};

export default Notifications;
